import { ref } from 'vue'

export type SubmitState = 'idle' | 'submitting' | 'submitted'
export type SubmitErrorKind = 'network' | 'server' | null

export function useSubmit() {
  const mountedAt = Date.now()
  const honeypot = ref('')
  const turnstileToken = ref('')
  const state = ref<SubmitState>('idle')
  const errorKind = ref<SubmitErrorKind>(null)
  const errorDetail = ref<string>('')

  function spamFields(): { key: string; value: string }[] {
    return [
      { key: '_hp', value: honeypot.value },
      { key: '_dt', value: String(Date.now() - mountedAt) },
      { key: '_turnstile', value: turnstileToken.value },
    ]
  }

  function reset() {
    state.value = 'idle'
    errorKind.value = null
    errorDetail.value = ''
  }

  return {
    honeypot,
    turnstileToken,
    state,
    errorKind,
    errorDetail,
    spamFields,
    reset,
  }
}
